import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { sdk } from '@/services';

const EventService = sdk.getService('EventService');

export const useLiveClass = () => {
  const { meetingId } = useParams<{ meetingId: string }>();

  const { isLoading, data, error } = useQuery({
    queryKey: ['events', 'live-class', meetingId],
    queryFn: () => EventService.getLiveClass(meetingId!),
    enabled: !!meetingId,
    staleTime: Infinity
  });

  return {
    data,
    isLoading,
    error
  };
};
